






















import Vue from "vue";
// @ts-ignore
import { directive as onClickaway } from "vue-clickaway";
export default Vue.extend({
	name: "YTSearchBox",
	directives: {
		onClickaway,
	},
	props: {
		value: {
			type: String,
			required: true,
		},
	},
	computed: {
		vModel: {
			get() {
				// @ts-ignore
				return this.value;
			},
			set(v: String) {
				// @ts-ignore
				this.$emit("input", v);
			},
		},
	},
});
